<template>
  <div>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <PageContent>
      <Container>
        <div
          v-if="setting"
          class="schedule"
          :class="{ 'is-loading': calenderLoading }"
        >
          <div class="schedule-calender">
            <Datepicker
              v-model="date"
              :inline="true"
              :fullMonthName="true"
              :dayCellContent="dayCellContent"
              @changedMonth="changedMonth"
            />
          </div>
          <ul class="schedule-colors">
            <li
              v-for="(type, index) in setting.type_list"
              :key="type.type"
              class="schedule-color"
            >
              <span :class="[`schedule-color-${index + 1}`]" />
              <span v-html="$domUtils.clear(type.sample)" />
            </li>
          </ul>
          <footer class="schedule-footer">
            <p
              class="text-paragraph"
              v-html="$domUtils.nl2br(setting.comment)"
            />
          </footer>
        </div>
      </Container>
    </PageContent>
  </div>
</template>

<script>
import moment from 'moment'
import Datepicker from '@/components/Datepicker.vue'
import { renderError } from '@/utils/error'
import api from '@/api/producer'

function getStartDate(date) {
  const m = date ? moment(date) : moment()
  return m.startOf('month').format('YYYY-MM-DD')
}

export default {
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'producer' }
    }
  },

  components: {
    Datepicker,
  },

  data() {
    return {
      calenderLoading: false,
      setting: null,
      date: '',
      scheduleList: [],
      holidayList: [],
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
  },

  methods: {
    async fetchSetting() {
      try {
        this.setting = await api.setting(this.businessId)
      } catch(err) {
        renderError(err)
      }
    },
    yearMonth() {
      const m = moment(this.date)
      return [m.year(), m.month() + 1]
    },
    async fetchSchedule() {
      try {
        this.calenderLoading = true
        const [year, month] = this.yearMonth()
        const response = await api.show(this.businessId, year, month)
        this.scheduleList = response.schedule_list
        this.holidayList = response.holiday_list
      } catch(err) {
        renderError(err)
      } finally {
        this.calenderLoading = false
      }
    },
    // 日付のレンダリング
    // Vue Datepicker の props
    dayCellContent(day) {
      const classNames = ['custom-day']

      // 後続の比較処理のために、年月を付加する
      const fullDate = moment(this.date).date(day.date).format('YYYY-MM-DD')

      // スケジュールリストに含まれるか？
      const highlight = this.scheduleList.find(item => item.date === fullDate)

      if (highlight) {
        // タイプ値を取り出して CSS クラスに含める
        const type = highlight.type
        classNames.push(`schedule-color-${type}`)
      }

      // 祝日に含まれるか？
      if (this.holidayList.map(item => item.date).includes(fullDate)) {
        classNames.push('holiday')
      }

      // 色付け用の span でラップする
      return `<span class="${classNames.join(' ')}">${day.date}</span>`
    },
    // 月変更時の処理
    // カレンダーの左右矢印をクリックしたときに呼ばれる
    async changedMonth(val) {
      const date = val instanceof Date ? val : new Date(val.timestamp)
      this.date = getStartDate(date)

      // スケジュールリストを取り直す
      await this.fetchSchedule()
    }
  },

  created() {
    // 初期値は現在月の月初
    // ここでは datepicker は表示のみで選択機能は不要なので、便宜上1日を選択値とする
    this.date = getStartDate()

    this.$withLoading(async () => {
      await this.fetchSetting()
      this.fetchSchedule()
    })
  },
}
</script>
